import { render, staticRenderFns } from "./ConfirmReviewRequest.vue?vue&type=template&id=579dcea8&scoped=true"
import script from "./ConfirmReviewRequest.vue?vue&type=script&lang=ts"
export * from "./ConfirmReviewRequest.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmReviewRequest.vue?vue&type=style&index=0&id=579dcea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579dcea8",
  null
  
)

export default component.exports